const UnauthorizedPage = () => {
  return (
    <div style={{ textAlign: "center", marginTop: "100px" }}>
      <h2>403 - Access Denied</h2>
      <p>You do not have permission to access this page.</p>
    </div>
  );
};

export default UnauthorizedPage;
